import React from 'react';
import styled from 'styled-components';

// import CockpitHeader from 'webmotors-cockpit-structure/CockpitHeader';
// import CockpitFooter from 'webmotors-cockpit-structure/CockpitFooter';
import Card from '../Campanhas/Card';
import { HeaderLogin, BodyLogin } from './style';

import * as S from '../utilities/styledComponents/Gearbox';

import FormUserLogin from '../FormUserLogin';

import envConfig from '../../config/environments';

const config = envConfig;// eslint-disable-line

const CockpitStyle = styled.div`
	background-color: #FFFFFF;

	.svg svg {
		min-height: 16px;
		min-width: 16px;
		max-width: 256px;
		max-height: 256px;
	}

	.cockpit-footer * {
		color: #8B8C99;
	}

	.App {
		background-color: #ECEDF2;
	}

	.cockpit-header__logo {
		margin-top: 1px;
	}
`;

const UserLogin = () => (
	<CockpitStyle>
		{/* <CockpitHeader logged={false} UrlCockpit={config.cockpitUrl} /> */}

		<S.MainContent id="gearbox-content">
			<div className="App">
				<div className="container">
					<div className="row">
						<div className="col-12">
							<div>
								<div className="card-create-account">
									<Card
										borderRadius="20px"
										padding="0"
									>
										<HeaderLogin
											className="d-flex justify-content-center"
										>
											<h2>Login</h2>
										</HeaderLogin>
										<BodyLogin>
											<FormUserLogin />
										</BodyLogin>
									</Card>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</S.MainContent>

		{/* <CockpitFooter logged={false} UrlCockpit={config.cockpitUrl} /> */}
	</CockpitStyle>
);

export default UserLogin;
